<div [hidden]="!active" class="mt-5 mb-5" style="position: relative;">
    <form #loginForm="ngForm" (ngSubmit)="saveComment()" >
        <div class="d-flex wrapper" >
            <div class="logo">
                <img
                    [src]="
                        profilePicture
                            ? profilePicture
                            : 'assets/common/images/default-profile-picture.png'
                    "
                    class="mr-3 rounded-circle w-100"
                />
            </div>
            <div class="w-80 pt-1">
                <div class="d-flex flex-column">
                    <div>
                        <div
                            class="w-100"
                            id="commentBody"
                            cols="20"
                            rows="1"
                            (input)="extendTextAreaHandler($event)"
                            (keyup)="mentionContact($event)"
                            [(ngModel)]="comment.body"
                            #CommentTextArea
                            [required]="true"
                            [maxlength]="maxAcceptedChars"
                            contenteditable="true"
                        ></div>
                        <div [ngStyle]="{'left':suggListContLeft+'px','top':suggListTop+'px'}"
                         class="suggstions-contact-list" *ngIf="showContactSuggstions">
                             <ul class="contact-list-cont" *ngIf="mentionSuggList">
                                <li *ngFor="let contact of mentionSuggList"
                                 class="contact" (click)="addContact({name:contact.userName,
                                 id:contact.id,
                                 userId:contact.userId,
                                 tenantId:contact.tenantId,
                                 tenantName:contact.tenantName,
                                })">{{contact.userName}}</li>
                             </ul>
                        </div>
                        <ng-container *ngIf="cartStyle;">

                        <button
                        [disabled]="!comment.body"
                        [buttonBusy]="saving"
                        [busyText]="emptyText"
                        class="send-comment-icon ">
                        <!-- <i class="">  <img src="../../../../../assets/message/Frame 13.png" /></i> -->
                        <svg class="mt-2" width="20" height="25" viewBox="0 0 20 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3072 7.10294L7.7071 12.8203L0.803747 9.94886C0.321882 9.74805 -0.00275487 9.18397 1.76209e-05 8.55025C0.00282659 7.91654 0.331184 7.35592 0.81491 7.16211L18.4644 0.0705149C18.8839 -0.0977572 19.3444 0.0403379 19.6561 0.42918C19.9677 0.818022 20.0784 1.39252 19.9435 1.916L14.2597 23.9371C14.1044 24.5406 13.6551 24.9503 13.1472 24.9538C12.6392 24.9573 12.1871 24.5522 12.0262 23.951L9.71361 15.296L14.3072 7.10294Z" fill="#F88011"/>
                            </svg>
                            
                            
                        </button>
                    </ng-container>
                    </div>
                    <div class="d-flex justify-content-between align-item-center">
                        <div class="mt-1 ml-3">
                            <ng-container *ngIf="!cartStyle;">

                            <button
                                *ngIf="comment.body || hasText"
                                [disabled]="loginForm.invalid"
                                [buttonBusy]="saving"
                                [busyText]="l('SavingWithThreeDot')"
                                class="btn btn-primary" style="background-color: #F88011 !important;
                                border: #F88011 !important;">
                                    {{ "Send" | localize }}
                            </button>
                            </ng-container>
                        </div>
                        <!-- <div class="pr-4">
                            <span
                                >{{ writtenChars }}/{{ maxAcceptedChars }}
                                {{ "characters" | localize }}</span
                            >
                        </div> -->
                    </div>
                </div>
            </div>

        </div>
    </form>
</div>
